<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default { name: 'App' };
</script>

<style>
/* 全局样式已在 reset 和 global 中定义 */
</style>